import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useMerchantReviews = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    ["merchantReviews"],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/product/merchant/me/reviews`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    },
    { enabled: !!token }
  );
};

export default useMerchantReviews;
